import React from "react";
import axios from "axios";
import Moment from "react-moment";
import PageTitle from "../../components/common/PageTitle";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Container,
  Button,
} from "shards-react";

class CBPListParticipants extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      currentPage: 1,
      totalPages: 0,
      search: "",
      isFetching: false,
      pageLimit: 10,
      listType: null,
    };
  }

  tableConfig = {
    accomplishment: {
      columns: [
        { key: "Participant Name", value: "participant_name" },
        { key: "Participant Email", value: "participant_email" },
        { key: "Project Name", value: "project" },
        { key: "Description", value: "description" },
        {
          key: "Start Date",
          value: "accomplishment_start_date",
          format: (date) => <Moment format="DD-MMM-YYYY">{date}</Moment>,
        },
        {
          key: "End Date",
          value: "accomplishment_end_date",
          format: (date) => <Moment format="DD-MMM-YYYY">{date}</Moment>,
        },
        {
          key: "Certificate Code",
          value: "accomplishment_certificate_code",
        },
      ],
    },
    participation: {
      columns: [
        { key: "Participant Name", value: "participant_name" },
        { key: "Participant Email", value: "participant_email" },
        {
          key: "Start Date",
          value: "participation_start_date",
          format: (date) => <Moment format="DD-MMM-YYYY">{date}</Moment>,
        },
        {
          key: "End Date",
          value: "participation_end_date",
          format: (date) => <Moment format="DD-MMM-YYYY">{date}</Moment>,
        },
        {
          key: "Certificate Code",
          value: "participation_certificate_code",
        },
      ],
    },
    impact_fest: {
      columns: [
        { key: "Participant Name", value: "participant_name" },
        { key: "Participant Email", value: "participant_email" },
        { key: "Project Name", value: "project" },
        { key: "Description", value: "description" },
        {
          key: "Start Date",
          value: "start_date",
          format: (date) => <Moment format="DD-MMM-YYYY">{date}</Moment>,
        },
        {
          key: "End Date",
          value: "end_date",
          format: (date) => <Moment format="DD-MMM-YYYY">{date}</Moment>,
        },
        {
          key: "Certificate Code",
          value: "certificate_code",
        },
      ],
    },
  };

  getParticipants = (page = 1) => {
    let { cbpID } = this.props.match.params;
    this.setState({ isFetching: true });

    axios
      .get(`${process.env.REACT_APP_API_URL}/cbp/${cbpID}`, {
        params: {
          page,
          limit: this.state.pageLimit,
          search: this.state.search,
        },
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        const { metadata, totalPages, participants, currentPage } = res.data;
        this.setState({
          data: participants,
          currentPage: currentPage,
          totalPages: totalPages,
          listType:
            metadata.eventType === "impact_fest"
              ? metadata.eventType
              : metadata.certificateType,
          isFetching: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching participants:", error);
        this.setState({ isFetching: false });
      });
  };

  handleSearch = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue });
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.getParticipants();
    }, 300);
  };

  componentDidMount() {
    this.getParticipants();
  }

  handlePageChange = (page) => {
    this.getParticipants(page);
  };

  render() {
    const { listType, data, currentPage, pageLimit, totalPages } = this.state;
    const config = this.tableConfig[listType] || { columns: [] };
    return (
      <React.Fragment>
        <Container fluid className="main-content-container px-4">
          <Row
            noGutters
            className=" d-flex flex-row page-header py-4 justify-content-between"
          >
            <PageTitle
              sm="4"
              title="Participants List"
              subtitle=""
              className="text-sm-left"
            />
            <input
              type="text"
              id="search"
              onChange={this.handleSearch}
              placeholder="Search"
              className="form-control mr-2 col-2 p-2"
              required="required"
            />
          </Row>
          <Row>
            <Col>
              <Card small className="mb-4 px-3">
                <CardHeader className="border-bottom"></CardHeader>
                <CardBody className="p-0 pb-3">
                  <div className="table-responsive">
                    <table className="table mb-0" id="my-table">
                      <thead className="bg-light">
                        <tr>
                          <th scope="col" className="border-0">
                            S.N.
                          </th>
                          {config.columns.map((column, idx) => (
                            <th key={idx} scope="col" className="border-0">
                              {column.key}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, index) => (
                          <tr key={index}>
                            <td>{(currentPage - 1) * pageLimit + index + 1}</td>
                            {config.columns.map((column, colIdx) => {
                              const value = item[column.value];

                              console.log({ column });

                              return (
                                <td key={colIdx}>
                                  {column.format ? column.format(value) : value}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {totalPages > 1 && (
                    <Row className="d-flex justify-content-end">
                      <div className="pagination mt-3 mr-5">
                        <Button
                          outline
                          size="sm"
                          theme={currentPage > 1 ? "primary" : "secondary"}
                          className="mb-2 mr-1"
                          disabled={currentPage <= 1}
                          onClick={() => this.handlePageChange(currentPage - 1)}
                        >
                          Previous
                        </Button>
                        <span className="mx-2">
                          Page {currentPage} of {totalPages}
                        </span>
                        <Button
                          outline
                          size="sm"
                          theme={
                            currentPage < totalPages ? "primary" : "secondary"
                          }
                          className="mb-2 mr-1"
                          disabled={currentPage >= totalPages}
                          onClick={() => this.handlePageChange(currentPage + 1)}
                        >
                          Next
                        </Button>
                      </div>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default CBPListParticipants;
